/**
 * AddGroupsControl
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useApi2call } from 'containers/Api2/index.js';
import { GROUPTYPES_CLASS, GROUPTYPES_GENERAL } from 'containers/User/constants.js';
import IconButton from 'components/interaction/IconButton/index.jsx';
import SelectUsers from 'components/interaction/SelectUsers/index.jsx';
import { idValues } from 'utils/arrays.js';
import { getIdNumber } from 'utils/userIdRole.js';
import messages from '../messages.js';

function AddGroupsControl(props) {
  const { user, onChange, ...rest } = props;
  const groups = idValues(user.groups);
  const [show, setShow] = useState(false);
  const api2call = useApi2call();
  const selectOptions = {
    roles: [
      { id: GROUPTYPES_CLASS, name: 'classes' },
      { id: GROUPTYPES_GENERAL, name: 'general' },
    ],
    fetchOptions: {
      url: 'sa/groups',
      version: 2,
      typeField: 'groupType',
    },
  };
  const exclusions = groups.map(getIdNumber);

  async function handleAdd(grps) {
    const newGroups = grps.filter((g) => !exclusions.includes(getIdNumber(g)));
    await api2call({
      method: 'POST',
      url: `sa/users/${user.typeName}/${user.id}/groups`,
      version: 2,
      body: {
        groupIds: newGroups.map((g) => g.id),
      },
      withPromise: true,
    });
    if (onChange) {
      onChange();
    }
  }

  return (
    <>
      <IconButton icon="ss-plus" variant="link" {...rest} onClick={() => setShow(true)}>
        <FormattedMessage {...messages.add} />
      </IconButton>
      <SelectUsers
        {...selectOptions}
        show={show}
        value={groups}
        exclusions={groups.map(getIdNumber)}
        onChange={handleAdd}
        onHide={() => setShow(false)}
        prompt={messages.selectGroups}
        clientSearch
      />
    </>
  );
}

AddGroupsControl.propTypes = {
  user: PropTypes.object,
  onChange: PropTypes.func,
};

export default AddGroupsControl;
